import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  number: '01',
  title: 'Tell us about your needs',
  description: "Fill out a quick form or give us a call. We'll ask a few simple questions to understand your health needs, budget, and preferred doctors."
}, {
  number: '02',
  title: 'We compare top carriers',
  description: 'Our licensed agents shop the market, comparing plans from 20+ top-rated insurance companies to find the best matches for you.'
}, {
  number: '03',
  title: 'You pick the best plan',
  description: 'We present your options clearly, without the jargon. You choose the plan you like best, and we handle the enrollment paperwork.'
}];
export function HowItWorks() {
  return <section className="py-24 bg-navy text-white relative overflow-hidden" data-id="element-234">
      {/* Decorative background */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-navy-light/30 skew-x-12 translate-x-32 pointer-events-none" data-id="element-235"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-236">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-237">
          <h2 className="text-4xl font-bold mb-4 text-white" data-id="element-238">
            Getting covered is simple.
          </h2>
          <p className="text-lg text-slate-300" data-id="element-239">
            Skip the endless research and confusing terminology. We guide you
            through a proven 3-step process.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 lg:gap-12 relative" data-id="element-240">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-0.5 bg-white/10" data-id="element-241"></div>

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="relative pt-8" data-id="element-242">
              <div className="w-16 h-16 bg-accent rounded-2xl flex items-center justify-center text-2xl font-bold text-navy-dark mb-6 mx-auto md:mx-0 relative z-10 shadow-lg transform -rotate-3 hover:rotate-0 transition-transform" data-id="element-243">
                {step.number}
              </div>
              <h3 className="text-2xl font-bold mb-4 text-center md:text-left" data-id="element-244">
                {step.title}
              </h3>
              <p className="text-slate-300 leading-relaxed text-center md:text-left" data-id="element-245">
                {step.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}